import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ContainerMaxWidth } from 'components/organisms/layouts/Layout';
import Image from 'next/image';
import { Colors, DesktopPadding, MobilePadding } from 'pages/index';
import { FC, useState } from 'react';
import styled from 'styled-components';
export const TESTIMONIAL_ITEMS = [{
  description: `With our diverse vehicle offerings from Ewing Automotive Group, consistency is key as we all strive towards an increasingly electric mobility future. Lectrium has empowered our dealerships to merchandise and showcase EV benefits in a way that informs, educates, and encourages shoppers to consider EV options. Not only are VDP visitors engaging with the insight, the Lectrium tools work hand-in-hand OEM EV priorities – with noticeable positive results.`,
  author: `Alex Keenan, Corporate Head of Marketing & Strategy at Ewing Automotive Group`,
  note: 'Ewing Automotive Group is a family-owned dealership group located in Plano, Texas',
  logo: `/assets/images/dealership-logos/ewing.png`,
  clientPhoto: `/assets/images/testimonials/ewing.png`
}, {
  author: 'Carolina Pereira, Marketing & Technology Director at Weston Volvo Cars',
  note: 'Weston Volvo Cars is one of Florida’s top rated Volvo dealerships',
  clientPhoto: `/assets/images/testimonials/carolina.png`,
  logo: `/assets/images/dealership-logos/weston.png`,
  description: `Lectrium’s VDP website add-on to our vehicles have become a huge benefit to our sales team, making it easier to engage in a conversation with customers over the phone or at the store open to leasing or purchasing an EV or Hybrid car. We are now able to explain faster and more efficiently – through visuals -  the added benefits of considering an EV or Hybrid based on every customer’s vehicle choice. I highly recommend the tool to any dealer – it empowers both customers and your sales team to feel comfortable with considering an electric-powered engine vehicle as a strong contender for their next purchase.`
}, {
  description: `What the automotive industry needs is a SaaS provider that understands EVs and is all about building the vehicle electrification movement to help dealers and consumers solve the Climate Crisis. Lectrium is perfectly positioned to do this with their commitment to transparency, quality and customer experience.`,
  author: `Jesse, Owner at Green Wave Electric Vehicles`,
  note: 'Green Wave Electric Vehicles is the largest independent used EV dealership in New Hampshire',
  logo: `/assets/images/testimonials/logo/green-wave.png`,
  clientPhoto: `/assets/images/testimonials/green-wave.png`
}, {
  description: `At Mark Miller Subaru, we're thrilled to introduce our partnership with a fantastic team dedicated to helping our customers understand the potential savings of switching to EVs. Working with our partners on this initiative has been incredibly productive and enlightening, further solidifying our leadership in eco-friendly automotive solutions.`,
  author: `Nate, Marketing Director at Mark Miller Subaru`,
  note: 'Mark Miller Subaru is one of the largest electric Subaru Solterra dealerships in the USA',
  logo: `/assets/images/testimonials/logo/mark-miller.png`,
  clientPhoto: `/assets/images/testimonials/mark-miller-2.png`
}, {
  description: `BMW of Idaho Falls has found great success selling EVs in the challenging market of Idaho. With the help of Lectrium we have been able so showcase potential savings customers can expect when they make the change to an EV right on our website. We have found Lectrium to be great productive partner in our quest to evolve with the ever-changing EV marketplace.`,
  author: `M'Kay, Sales Manager at BMW of Idaho Falls`,
  note: 'BMW of Idaho Falls is a premier electric vehicle dealership near Yellowstone National Park and Jackson Wyoming',
  logo: `/assets/images/dealership-logos/bmw-of-idaho-falls.png`,
  clientPhoto: `/assets/images/testimonials/mkay.png`
}];
type TestimonialsProps = {
  excludeJesse?: boolean;
  testimonials?: {
    description: string;
    author: string;
    note: string;
    logo: string;
    clientPhoto: string;
  }[];
  title?: string;
};
export const Testimonials: FC<TestimonialsProps> = ({
  excludeJesse = false,
  testimonials = TESTIMONIAL_ITEMS,
  title = 'Building EV value for our dealer partners'
}) => {
  const filteredTestimonials = excludeJesse ? testimonials.filter(testimonial => testimonial.author !== 'Jesse, Owner at Green Wave Electric Vehicles') : testimonials;
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const item = filteredTestimonials[currentIndex];
  const goBack = () => {
    if (currentIndex - 1 < 0) {
      setCurrentIndex(filteredTestimonials?.length - 1);
    } else {
      setCurrentIndex(currentIndex - 1);
    }
  };
  const goForward = () => {
    if (currentIndex + 1 >= filteredTestimonials?.length) {
      setCurrentIndex(0);
    } else {
      setCurrentIndex(currentIndex + 1);
    }
  };
  if (isMobile) {
    return <Box sx={{
      backgroundColor: Colors.White,
      padding: {
        xs: '24px 10px',
        md: DesktopPadding
      }
    }} id="testimonials">
        <Typography sx={{
        fontSize: '38px',
        textAlign: 'center',
        fontWeight: 700,
        mb: 2
      }}>
          {title}
        </Typography>
        <Box sx={{
        display: 'flex',
        alignItems: 'flex-start'
      }}>
          <Box sx={{
          mr: '0.5rem',
          mt: '8rem'
        }}>
            {testimonials?.length > 1 ? <Box sx={{
            backgroundColor: Colors.CeruleanBlue,
            width: 20,
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50px',
            cursor: 'pointer'
          }} onClick={goBack}>
                <Image src="/assets/svg/chevron-left-white.svg" alt="" width={6} height={6} />
              </Box> : <Box />}
          </Box>

          <Box sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'column'
        }}>
            <Box sx={{
            mb: '0.5rem',
            display: 'flex',
            gap: '0.5rem',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
              <Image src={item?.clientPhoto || ''} width={200} height={240} alt="" style={{
              objectFit: 'cover'
            }} />
              <Box sx={{
              textAlign: 'center'
            }}>
                <Typography sx={{
                color: Colors.CeruleanBlue,
                fontSize: 14,
                fontWeight: 600,
                mb: 0.5
              }}>
                  {item?.author}
                </Typography>
                <Typography sx={{
                color: Colors.RiverBed,
                fontSize: 12,
                fontWeight: 400
              }}>
                  {item?.note}
                </Typography>
              </Box>
            </Box>

            <Box sx={{
            border: '1px solid #B9F0D6',
            padding: '12px',
            borderRadius: '2px',
            height: 'auto',
            alignSelf: 'stretch'
          }}>
              <Box sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mb: 1
            }}>
                <Image src={item?.logo || ''} width={80} height={80} alt="" style={{
                borderRadius: '2px',
                objectFit: 'contain',
                height: '80px',
                width: '80px'
              }} />
              </Box>
              <Box sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              mb: 1
            }}>
                <Image src={`/assets/quotation-marks-start.svg`} width={20} height={20} alt="" />
              </Box>
              <Typography sx={{
              color: '#44485A',
              fontSize: '14px',
              fontWeight: 400,
              my: '0.25rem',
              lineHeight: 1.4
            }}>
                {item?.description}
              </Typography>
              <Box sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              mt: 1
            }}>
                <Image src={`/assets/quotation-marks-end.svg`} width={20} height={20} alt="" />
              </Box>
            </Box>
          </Box>

          <Box sx={{
          ml: '0.5rem',
          mt: '8rem'
        }}>
            {testimonials?.length > 1 ? <Box onClick={goForward} sx={{
            backgroundColor: Colors.CeruleanBlue,
            width: 20,
            height: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            borderRadius: '50px'
          }}>
                <Image src="/assets/svg/chevron-right-white.svg" alt="" width={6} height={6} />
              </Box> : <Box />}
          </Box>
        </Box>
      </Box>;
  }
  return <Box sx={{
    backgroundColor: Colors.White,
    padding: {
      xs: MobilePadding,
      md: DesktopPadding
    },
    px: {
      xs: 0,
      md: '2%'
    },
    mx: 'auto',
    maxWidth: ContainerMaxWidth
  }} id="testimonials">
      <Typography sx={{
      fontSize: '38px',
      textAlign: 'center',
      fontWeight: 700
    }}>
        {title}
      </Typography>

      <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mt: '3rem'
    }}>
        {testimonials?.length > 1 ? <StyledArrowContainer sx={{
        backgroundColor: Colors.CeruleanBlue,
        width: 30,
        height: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50px',
        cursor: 'pointer'
      }} onClick={goBack}>
            <Image src="/assets/svg/chevron-left-white.svg" alt="" width={8} height={8} />
          </StyledArrowContainer> : <Box />}

        <Box>
          <Image src={item?.clientPhoto || ''} width={400} height={350} alt="" objectFit="cover" style={{
          objectFit: 'cover'
        }} />
          <Box sx={{
          pt: '1rem',
          maxWidth: '400px'
        }}>
            <Typography sx={{
            color: Colors.CeruleanBlue,
            fontSize: 16,
            fontWeight: 600
          }}>- {item?.author}</Typography>
            <Typography sx={{
            color: Colors.RiverBed,
            fontSize: 16,
            fontWeight: 400
          }}>{item?.note}</Typography>
          </Box>
        </Box>

        <Box sx={{
        border: '1px solid #B9F0D6',
        padding: '24px',
        maxWidth: '45%',
        borderRadius: '2px',
        height: 'auto',
        alignSelf: 'stretch'
      }}>
          <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
            <Image src={item?.logo || ''} width={120} height={120} alt="" style={{
            borderRadius: '2px',
            objectFit: 'contain',
            height: '120px',
            width: '120px'
          }} />
          </Box>
          <Box sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          my: '1rem'
        }}>
            <Image src={`/assets/quotation-marks-start.svg`} width={30} height={30} alt="" />
          </Box>
          <Typography sx={{
          color: '#44485A',
          fontSize: '16px',
          fontWeight: 400,
          my: '0.25rem'
        }}>
            {item?.description}
          </Typography>
          <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          my: '1rem'
        }}>
            <Image src={`/assets/quotation-marks-end.svg`} width={30} height={30} alt="" />
          </Box>
        </Box>

        {testimonials?.length > 1 ? <StyledArrowContainer onClick={goForward} sx={{
        backgroundColor: Colors.CeruleanBlue,
        width: 30,
        height: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        borderRadius: '50px'
      }}>
            <Image src="/assets/svg/chevron-right-white.svg" alt="" width={8} height={8} />
          </StyledArrowContainer> : <Box />}
      </Box>
    </Box>;
};
const StyledArrowContainer = styled(Box)`
  :hover {
    background-color: #4759cb;
  }
`;